import { Check, Loader2, ArrowLeft } from "lucide-react";
import Logo from "./Logo";
import StepIndicator from "./StepIndicator";
import { Switch } from "./Switch";

export default function StepFiveFeatures({
  formData,
  handleInputChange,
  handleFinalSubmit,
  handlePrevStep,
  isLoading,
  handleCancel,
}) {
  const handleToggle = (field, checked) => {
    handleInputChange(`features.${field}`, checked);
  };

  return (
    <div className="min-h-screen flex items-start justify-center pt-1 p-4" style={{ backgroundColor: '#ffffff' }}>
      <div className="bg-white rounded-2xl   p-8 w-full max-w-md">
        <Logo />
        <StepIndicator currentStep={5} />

        <h2 className="text-xl font-semibold text-gray-900 mb-6">
          Enable Features
        </h2>

        <div className="space-y-4 mb-6">
          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
            <span className="text-sm font-medium text-gray-700">
              Taking Messages
            </span>
            <Switch
              checked={formData.features.takingMessages}
              onCheckedChange={(checked) => handleToggle("takingMessages", checked)}
            />
          </div>
          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
            <span className="text-sm font-medium text-gray-700">
              Book Appointments
            </span>
            <Switch
              checked={formData.features.bookAppointments}
              onCheckedChange={(checked) => handleToggle("bookAppointments", checked)}
            />
          </div>
          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
            <span className="text-sm font-medium text-gray-700">
              Appointment Reminder
            </span>
            <Switch
              checked={formData.features.appointmentReminder}
              onCheckedChange={(checked) => handleToggle("appointmentReminder", checked)}
            />
          </div>
          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
            <span className="text-sm font-medium text-gray-700">
              Transfer Call
            </span>
            <Switch
              checked={formData.features.transferCall}
              onCheckedChange={(checked) => handleToggle("transferCall", checked)}
            />
          </div>
        </div>

        <button
          onClick={handleFinalSubmit}
          disabled={isLoading}
          className="w-full py-4 bg-gradient-to-r from-green-500 to-teal-600 text-white rounded-lg hover:from-green-600 hover:to-teal-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center space-x-2"
        >
          {isLoading ? (
            <>
              <Loader2 size={20} className="animate-spin" />
              <span>Finishing Up...</span>
            </>
          ) : (
            <>
              <Check size={20} />
              <span>Complete Onboarding</span>
            </>
          )}
        </button>

        <div className="flex justify-between items-center mt-4">
          <button
            onClick={handlePrevStep}
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft size={20} />
            <span>Back</span>
          </button>
          <button
            onClick={handleCancel}
            className="py-3 px-4 text-red-600 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}